import { Redirect } from 'expo-router';
import { ROUTES } from '@/utils/constants';

export default function NotFoundScreen() {
  return <Redirect href={ROUTES.LOGIN} />;
}
